import React from "react";
import Modal from "components/common/Modal";

interface HtmlRendererProps {
  isOpen: boolean;
  onClose: () => void;
  content?: string;
  heading: any;
}

const HtmlRenderer: React.FC<HtmlRendererProps> = ({ isOpen, onClose, content, heading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-[35rem] pb-2" headerClassName="bg-[#F0F4FD] -mt-5 py-5 rounded-t-lg" header={<p className="font-bold">{heading}</p>}>
      <div className="px-5 pb-5 max-h-[26rem] overflow-auto rounded-br-xl custom-scrollbar">{content && <div dangerouslySetInnerHTML={{ __html: content }} />}</div>
    </Modal>
  );
};

export default HtmlRenderer;
